import { createSlice, PayloadAction } from '@reduxjs/toolkit';
import { RenderingState, ErrorInfo } from 'redux/types';
import { RootState } from 'redux/root-reducer';

const initialState: RenderingState = {
  isLoading: false,
  success: false,
  error: {
    message: '',
    statusCode: null,
  },
};

const showInvitationSlice = createSlice({
  name: 'SHOW_INVITATION',
  initialState,
  reducers: {
    loading: (state) => {
      state.isLoading = true;
    },
    success: (state) => {
      state.isLoading = false;
      state.success = true;
      state.error = initialState.error;
    },
    failure: (state, action: PayloadAction<ErrorInfo>) => {
      state.isLoading = false;
      state.error = action.payload;
    },
  },
});

// REDUCER
export default showInvitationSlice.reducer;

// ACTIONS
export const { loading, success, failure } = showInvitationSlice.actions;

// SELECTORS
export const selectIsLoading = (state: RootState) =>
  state.ui.invitations.showInvitaion.isLoading;
export const selectSuccess = (state: RootState) =>
  state.ui.invitations.showInvitaion.success;
export const selectError = (state: RootState) => state.ui.invitations.showInvitaion.error;
